import { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en";
import et from "./et";
import it from "./it";

const DICTS = { en, et, it };
export const LANGS = ["en", "et", "it"];
const Ctx = createContext({ lang: "en", setLang: () => {}, t: en });

const initialLang = () => {
  const saved = localStorage.getItem("gj_lang");
  if (DICTS[saved]) return saved;
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return DICTS[nav] ? nav : "en";
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(initialLang);
  useEffect(() => {
    localStorage.setItem("gj_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = useMemo(() => ({ lang, setLang, t: DICTS[lang] }), [lang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
